// extracted by mini-css-extract-plugin
export var btn = "style-module--btn--98cdd";
export var btnBlock = "style-module--btn-block--64be3";
export var container = "style-module--container--2fdd0";
export var desc = "style-module--desc--a7d32";
export var fit = "style-module--fit--a279e";
export var info = "style-module--info--135d6";
export var oldPrice = "style-module--old-price--04b87";
export var price = "style-module--price--bfe11";
export var screen1 = "style-module--screen1--89854";